//
//
//
//

export default {
  props: {
    active: {
      default: false
    },
    value: {
      default: ''
    },
    background: {
      default: '#5DBFB9'
    }
  },
  methods: {
    buttonClick () {
      // this.active = true
      this.$emit('update:active', true)
      this.$emit('click')
    }
  },
  computed: {
    getButtonStyle () {
      if (this.active) {
        return `background: ${this.background}`
      }
      return `background:  #D2D2D2`
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/simple/appButtonCircle/App-button-circle.vue